// extracted by mini-css-extract-plugin
export default {"layout":"protected-layout_layout__RPi25"};